"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.configDefaults = exports.SESSION_INIT_MODE = void 0;
var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));
var SESSION_INIT_MODE = exports.SESSION_INIT_MODE = {
  LEGACY_ONLY: '0',
  BANGBANG_WITH_LEGACY_FALLBACK: '1',
  BANGBANG_ONLY: '2'
};
var configDefaults = exports.configDefaults = {
  nui: {
    sessionServiceDirect: {
      url: {
        value: '',
        useDefault: true
      }
    },
    signin: {
      domain: {
        value: '',
        useDefault: true,
        clientExposed: true
      },
      companiesToUsRedirect: {
        value: '',
        useDefault: true
      },
      urlToUsRedirect: {
        value: '',
        useDefault: true
      }
    },
    home: {
      domain: {
        value: '',
        useDefault: true,
        clientExposed: true
      }
    },
    cookies: {
      useSameSite: {
        value: true,
        useDefault: true,
        clientExposed: true
      }
    },
    signinapp: {
      value: false,
      useDefault: true,
      clientExposed: true
    },
    session: {
      url: '',
      timeout: {
        value: 3000,
        useDefault: true
      },
      init: {
        mode: {
          value: SESSION_INIT_MODE.BANGBANG_ONLY,
          useDefault: true
        },
        legacy: {
          url: {
            value: '',
            useDefault: true
          }
        },
        url: {
          value: '',
          useDefault: true
        },
        timeout: {
          value: 24600,
          useDefault: true
        }
      },
      cookie: {
        domain: {
          value: '',
          useDefault: true,
          clientExposed: true
        }
      }
    },
    jwt: {
      refresh: {
        url: {
          value: '/nui/signin/nui-auth/api/jwt',
          useDefault: true,
          clientExposed: true
        }
      }
    },
    oauth2: {
      url: {
        value: '',
        clientExposed: true
      },
      timeout: {
        value: 3000,
        clientExposed: true,
        useDefault: true
      },
      client: {
        id: {
          value: '',
          clientExposed: true,
          useDefault: true
        },
        secret: {
          value: '',
          useDefault: true
        }
      },
      scope: {
        value: '*',
        clientExposed: true,
        useDefault: true
      }
    },
    xdckey: {
      value: '',
      useDefault: true,
      clientExposed: false
    },
    apigateway: {
      server: {
        url: {
          useDefault: true,
          clientExposed: false,
          value: ''
        }
      },
      browser: {
        url: {
          useDefault: true,
          clientExposed: true,
          value: ''
        }
      }
    },
    x509: {
      keepAlive: {
        value: false,
        useDefault: true
      }
    },
    logos: {
      partner: {
        legacy: {
          url: {
            value: '',
            useDefault: true
          }
        },
        url: {
          value: '',
          useDefault: true
        }
      },
      company: {
        legacy: {
          url: {
            value: '',
            useDefault: true
          }
        },
        url: {
          value: '',
          useDefault: true
        }
      },
      timeout: {
        value: 2000,
        useDefault: true
      }
    },
    passwordless: {
      redirectUri: {
        'www': {
          value: 'https://www.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'us2': {
          value: 'https://us2.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'www-us2': {
          value: 'https://us2.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'eu2': {
          value: 'https://eu2.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'www-eu2': {
          value: 'https://eu2.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'cn': {
          value: 'https://www.concurcdc.cn/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'www-cn': {
          value: 'https://www.concurcdc.cn/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'integration': {
          value: 'https://integration.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'www-integration': {
          value: 'https://integration.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'apj1': {
          value: 'https://apj1.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'www-apj1': {
          value: 'https://apj1.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'usg': {
          value: 'https://usg.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        },
        'www-usg': {
          value: 'https://usg.concursolutions.com/nui/signin/setsession',
          useDefault: true,
          clientExposed: true
        }
      }
    }
  }
};
var _default = exports.default = (0, _nuiConfig.default)(configDefaults);